"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeprecatedClientEvents = exports.ClientEvents = exports.LoginModalDismissElements = exports.ShefBioPlacements = exports.BrowseByTagsType = exports.ShareType = exports.ReferralShareLocation = void 0;
var ReferralShareLocation;
(function (ReferralShareLocation) {
    ReferralShareLocation["ACCOUNT_SHARE"] = "account-share";
    ReferralShareLocation["POST_ORDER"] = "post-order";
    ReferralShareLocation["ACCOUNT_SHARE_SHEF"] = "account-share-shef";
    ReferralShareLocation["ACCOUNT_SHARE_FOOD_ITEM"] = "account-share-food-item";
    ReferralShareLocation["ACCOUNT_SHARE_ORDER"] = "account-share-order";
    ReferralShareLocation["AFTER_5_STAR_REVIEW"] = "after-5-star-review";
    ReferralShareLocation["BECOME_A_SHEF"] = "become-a-shef";
    ReferralShareLocation["WAITLIST"] = "waitlist";
    ReferralShareLocation["UPCOMING_MEAL_PLAN_ORDERS"] = "upcoming-meal-plan-orders";
    ReferralShareLocation["MANAGE_MEAL_PLAN"] = "manage-meal-plan";
})(ReferralShareLocation = exports.ReferralShareLocation || (exports.ReferralShareLocation = {}));
var ShareType;
(function (ShareType) {
    ShareType["WHATSAPP"] = "Whatsapp";
    ShareType["TWITTER"] = "Twitter";
    ShareType["FACEBOOK"] = "Facebook";
    ShareType["EMAIL"] = "Email";
    ShareType["TEXT"] = "Text";
    ShareType["COPY"] = "copy";
    ShareType["NATIVE"] = "native";
})(ShareType = exports.ShareType || (exports.ShareType = {}));
var BrowseByTagsType;
(function (BrowseByTagsType) {
    BrowseByTagsType["COLLECTION"] = "collection";
    BrowseByTagsType["DIETARY_PREFERENCE"] = "dietary-preference";
    BrowseByTagsType["CUISINE"] = "cuisine";
})(BrowseByTagsType = exports.BrowseByTagsType || (exports.BrowseByTagsType = {}));
var ShefBioPlacements;
(function (ShefBioPlacements) {
    ShefBioPlacements["SHEF_PIC"] = "shef_pic";
    ShefBioPlacements["SHEF_NAME"] = "shef_name";
})(ShefBioPlacements = exports.ShefBioPlacements || (exports.ShefBioPlacements = {}));
var LoginModalDismissElements;
(function (LoginModalDismissElements) {
    LoginModalDismissElements["CLOSE_BUTTON"] = "close";
    LoginModalDismissElements["BROWSE_AS_GUEST"] = "browse-as-guest";
})(LoginModalDismissElements = exports.LoginModalDismissElements || (exports.LoginModalDismissElements = {}));
var ClientEvents;
(function (ClientEvents) {
    ClientEvents["PURCHASE"] = "purchase";
    ClientEvents["EXISTING_USER_PURCHASE"] = "existing-user-purchase";
    ClientEvents["NEW_USER_PURCHASE"] = "new-user-purchase";
    ClientEvents["CART_ADD_ITEM"] = "cart-add-item";
    ClientEvents["CART_REMOVE_ITEM"] = "cart-remove-item";
    ClientEvents["FREE_DELIVERY_ADD_ITEM"] = "free-delivery-add-item";
    ClientEvents["PURCHASE_ATTEMPT"] = "purchase-attempt";
    ClientEvents["PURCHASE_ATTEMPT_FAILED"] = "purchase-attempt-failed";
    ClientEvents["SUBSCRIPTION_PURCHASE_ATTEMPT"] = "subscription-purchase-attempt";
    ClientEvents["SUBSCRIPTION_PURCHASE"] = "subscription-purchase";
    ClientEvents["MEAL_PLANNING_MVP_FOOD_ITEM_RENDERED"] = "meal-planning-mvp-food-item-rendered";
    ClientEvents["MEAL_PLANNING_MVP_CAROUSEL_TAB"] = "meal-planning-carousel-food-item-type-tab";
    ClientEvents["MEAL_PLANNING_MVP_MY_CUISINE_RESULTS"] = "meal-planning-mvp-my-cuisine-results";
    ClientEvents["MEAL_PLANNING_MVP_ADD_TO_CART"] = "meal_planning_mvp_add_to_cart";
    ClientEvents["MEAL_PLANNING_MVP_REMOVE_FROM_CART"] = "meal_planning_mvp_remove_from_cart";
    ClientEvents["MEAL_PLANNING_MVP_SIDE_OR_STAPLE_ADD"] = "meal_planning_mvp_side_or_staple_add";
    ClientEvents["MEAL_PLANNING_MVP_CHECKOUT_STARTED"] = "meal-planning-mvp-checkout-started";
    ClientEvents["MEAL_PLANNING_MVP_DELIVERY_ADDRESS_SELECT"] = "meal-planning-mvp-checkout-delivery-address-select";
    ClientEvents["MEAL_PLANNING_MVP_DELIVERY_TIME_SELECT"] = "meal-planning-mvp-checkout-delivery-time-select";
    ClientEvents["MEAL_PLANNING_MVP_CREDIT_CARD_INPUT"] = "meal-planning-mvp-checkout-credit-card-input";
    ClientEvents["MEAL_PLANNING_MVP_PURCHASE"] = "meal-planning-mvp-purchase";
    ClientEvents["MEAL_PLANNING_MVP_PURCHASE_ATTEMPT"] = "meal-planning-mvp-purchase-attempt";
    ClientEvents["MEAL_PLANNING_MVP_MORE_SHEFS_CLICK"] = "meal-planning-mvp-more-shefs-click";
    ClientEvents["MEAL_PLANNING_MVP_DISH_UPDATE_ATTEMPT"] = "meal-planning-mvp-dish-update-attempt";
    ClientEvents["MEAL_PLANNING_MVP_SKIP_DELIVERY_ATTEMPT"] = "meal-planning-mvp-skip-delivery-attempt";
    ClientEvents["MEAL_PLANNING_SERVING_SIZE_MODAL_SHOWN"] = "meal-planning-serving-size-modal-shown";
    ClientEvents["MEAL_PLANNING_SERVING_SIZE_INFO_MODAL_OPEN"] = "meal-planning-serving-size-info-modal-open";
    ClientEvents["MEAL_PLANNING_SPLASH_PAGE_LOADED"] = "meal-planning-splash-page-loaded";
    ClientEvents["MEAL_PLANNING_UPCOMING_ORDER_RENDERED"] = "meal-planning-upcoming-order-rendered";
    ClientEvents["MEAL_PLANNING_UNSKIP_DELIVERY"] = "meal-planning-unskip-delivery";
    ClientEvents["MEAL_PLANNING_UNSKIP_DELIVERY_ERROR"] = "meal-planning-unskip-delivery-error";
    ClientEvents["MEAL_PLANNING_UPCOMING_ORDER_PAGE_VIEW"] = "meal-planning-upcoming-order-page-loaded";
    ClientEvents["MEAL_PLANNING_UPCOMING_ORDER_BTN_CLICK"] = "meal-planning-upcoming-order-btn-click";
    ClientEvents["MEAL_PLANNING_EDIT_DELIVERY_DATE_BTN_CLICK"] = "meal-planning-edit-delivery-date-btn-click";
    ClientEvents["MEAL_PLANNING_MVP_IMPERFECT_MATCH_RESULTS"] = "meal-planning-mvp-imperfect-match-results";
    ClientEvents["MEAL_PLANNING_PREFERENCES_SUBMITTED"] = "meal-planning-preferences-submitted";
    ClientEvents["MEAL_PLANNING_EDIT_PREFERENCE_STARTED"] = "meal-planning-edit-preference-started";
    ClientEvents["MEAL_PLANNING_EDIT_PREFERENCE_SAVED"] = "meal-planning-edit-preference-saved";
    ClientEvents["MEAL_PLAN_SHEF_BIO_CLICK"] = "meal-plan-shef-bio-click";
    ClientEvents["MANAGE_SUBSCRIPTION_DROPDOWN"] = "manage-subscription-dropdown";
    ClientEvents["SUBSCRIPTION_CANCEL_MODAL_CONFIRMATION"] = "subscription-cancel-modal-confirmation";
    ClientEvents["MEAL_PLAN_OPEN_CART"] = "meal_plan_open_cart";
    ClientEvents["EXPLORE_PERSONAL_MEAL_PLAN_BANNER_SHOWN"] = "explore-personal-meal-plan-banner-shown";
    ClientEvents["EXPLORE_PERSONAL_MEAL_PLAN_BANNER_CLICKED"] = "explore-personal-meal_plan-banner-clicked";
    ClientEvents["EXPLORE_MEAL_PLAN_MODAL_SHOWN"] = "explore-meal-plan-modal-shown";
    ClientEvents["EXPLORE_MEAL_PLAN_MODAL_CLAIM_OFFER"] = "explore-meal-plan-modal-claim-offer";
    ClientEvents["EXPLORE_MEAL_PLAN_MODAL_CLOSED"] = "explore-meal-plan-modal-closed";
    ClientEvents["MEAL_PLAN_SIDE_MODAL_SHOWN"] = "meal-plan-side-modal-shown";
    ClientEvents["MEAL_PLAN_SIDE_MODAL_SHEF_RENDERED"] = "meal-plan-side-modal-shef-rendered";
    ClientEvents["MEAL_PLAN_REVIEW_ORDER_SHOWN"] = "meal-plan-review-order-shown";
    ClientEvents["MEAL_PLAN_REVIEW_ORDER_CLOSED"] = "meal-plan-review-order-closed";
    ClientEvents["MEAL_PLAN_DISH_TYPE_NAVIGATION"] = "meal-plan-dish-type-navigation";
    ClientEvents["MEAL_PLAN_SIDE_MODAL_DISMISSED"] = "meal-plan-side-modal-dismissed";
    ClientEvents["MEAL_PLAN_SIDE_MODAL_DONT_SHOW_AGAIN"] = "meal-plan-side-modal-dont-show-again";
    ClientEvents["MEAL_PLAN_BROWSE_EXPERIENCE_CLICK"] = "meal-plan-browse-experience-click";
    ClientEvents["INTAKE_HOUSEHOLD"] = "intake-household";
    ClientEvents["INTAKE_INGREDIENTS_TO_AVOID_OTHER"] = "intake-ingredients-to-avoid-other";
    ClientEvents["INTAKE_PORTION_SIZE_SELECTED"] = "intake-portion-size-selected";
    ClientEvents["MEAL_PLAN_FILTERS_APPLIED"] = "meal-plan-filters-applied";
    ClientEvents["MEAL_PLAN_EDIT_TASTE_PROFILE_CLICKED"] = "meal-plan-edit-taste-profile-clicked";
    ClientEvents["MEAL_PLAN_TASTE_PROFILE_EDITED"] = "meal-plan-taste-profile-edited";
    ClientEvents["MEAL_PLAN_TASTE_PROFILE_INTAKE"] = "meal-plan-taste-profile-intake";
    ClientEvents["HOMEPAGE_MEAL_PLAN_CLICK"] = "homepage-meal-plan-click";
    ClientEvents["HOMEPAGE_MARKETPLACE_CLICK"] = "homepage-marketplace-click";
    ClientEvents["MEAL_PLANNING_MANAGE_MEAL_PLAN_BTN_CLICK"] = "meal-planning-manage-meal-plan-btn-click";
    ClientEvents["MEAL_PLAN_MODIFIED_CLICKED"] = "meal-plan-modified-clicked";
    ClientEvents["MEAL_PLANNING_MODIFY_PLAN_FAILURE"] = "meal-planning-modify-plan-failure";
    ClientEvents["MEAL_PLANNING_PLAN_SETTINGS_INPUT_CLICK"] = "meal-planning-plan-settings-input-click";
    ClientEvents["MEAL_PLANNING_DELIVERY_DAY_INPUT_CLICK"] = "meal-planning-delivery-day-input-click";
    ClientEvents["MEAL_PLAN_NOT_AVAILABLE_ERROR"] = "meal-plan-not-available-error";
    ClientEvents["MEAL_PLANNING_MVP_INTAKE_FORM_STEP"] = "meal-planning-mvp-intake-form-step";
    ClientEvents["EXPLORE_MEAL_PLAN_HERO_BANNER_CLICK"] = "explore-meal-plan-hero-banner-click";
    ClientEvents["EXPLORE_MEAL_PLAN_HERO_BANNER_SHOWN"] = "explore-meal-plan-hero-banner-shown";
    ClientEvents["EXPLORE_MEAL_PLAN_HERO_BANNER_EXISTING_SUB_CLICK"] = "explore-meal-plan-hero-banner-existing-sub-click";
    ClientEvents["EXPLORE_MEAL_PLAN_HERO_BANNER_EXISTING_SUB_SHOWN"] = "explore-meal-plan-hero-banner-existing-sub-shown";
    ClientEvents["ORGANIZATION_LANDING"] = "organization-landing";
    ClientEvents["SHEF_APPLICATION_RECEIVED"] = "shef-application-received";
    ClientEvents["SUBSCRIPTION_MEAL_DETAILS_CLICK"] = "subscription-meal-details-click";
    ClientEvents["SHARED_NONE"] = "share-none";
    ClientEvents["SHARE_SHEF_MENU"] = "share-shef-menu";
    ClientEvents["SHARE_SHEF_FOOD_ITEM"] = "share-shef-food-item";
    ClientEvents["SHARE_SHEF_PROMO_CODE"] = "shate-shef-promo-code";
    ClientEvents["REFERRAL_CODE_COPIED"] = "referral-code-copied";
    ClientEvents["REFERRAL_CODE_SHARED"] = "referral-code-shared";
    ClientEvents["REFERRAL_CODE_SHARED_FACEBOOK"] = "referral-code-shared-facebook";
    ClientEvents["REFERRAL_CODE_SHARED_TWITTER"] = "referral-code-shared-twitter";
    ClientEvents["REFERRAL_CODE_SHARED_WHATSAPP"] = "referral-code-shared-whatsapp";
    ClientEvents["REFERRAL_CODE_SHARED_EMAIL"] = "referral-code-shared-email";
    ClientEvents["REFER_COMPOSE_EMAIL"] = "refer-compose-email";
    ClientEvents["FOOD_SEARCH"] = "food-search";
    ClientEvents["FOOD_SEARCH_RESULTS_DISPLAYED"] = "food-search-results-displayed";
    ClientEvents["SHEF_SEARCH_RESULT_CLICK"] = "shef-search-result-click";
    ClientEvents["FOOD_SEARCH_RESULT_CLICK"] = "food-search-result-click";
    ClientEvents["CUISINE_SEARCH_RESULT_CLICK"] = "cuisine-search-result-click";
    ClientEvents["SEARCH_SHOW_MORE_SHEFS_CLICK"] = "search-show-more-shefs-click";
    ClientEvents["SEARCH_SHOW_MORE_DISHES_CLICK"] = "search-show-more-dishes-click";
    ClientEvents["MORE_CUISINES_CLICK"] = "more-cuisines-click";
    ClientEvents["GIFT_CARD_SEARCH_RESULT_CLICK"] = "gift-card-search-result-click";
    ClientEvents["TRENDING_SEARCH_CLICK"] = "trending-search";
    ClientEvents["API_SYNC_RELOAD"] = "api-sync-reload";
    ClientEvents["SESSION_STARTED"] = "session-started";
    ClientEvents["BECOME_A_SHEF_VISIT"] = "become-a-shef-visit";
    ClientEvents["PAGE_VIEW"] = "page-view";
    ClientEvents["SUBMIT_DELIVERY_DAY_FILTER"] = "submit-delivery-day-filter";
    ClientEvents["CLICK_DIETARY_FILTER"] = "click-dietary-filter";
    ClientEvents["SUBMIT_DIETARY_FILTER"] = "submit-dietary-filter";
    ClientEvents["CLICK_SPICE_FILTER"] = "click-spice-filter";
    ClientEvents["SUBMIT_SPICE_FILTER"] = "submit-spice-filter";
    ClientEvents["SUBMIT_CUISINE_CATEGORY_FILTER"] = "submit-cuisine-category-filter";
    ClientEvents["SELECT_CUISINE_FILTER"] = "select-cuisine-filter";
    ClientEvents["CLICK_PICKUP_DISTANCE_FILTER"] = "click-pickup-distance-filter";
    ClientEvents["CAROUSEL_SWIPE"] = "carousel-swipe";
    ClientEvents["LANDING_ZIP_SUBMIT"] = "landing-zip-submit";
    ClientEvents["EXPLORE_ZIP_SUBMIT"] = "explore-zip-submit";
    ClientEvents["VIDEO_BIO_CLICK"] = "video-bio-click";
    ClientEvents["LEARN_MORE_CLICK"] = "learn-more-click";
    ClientEvents["CART_INCREMENT"] = "cart-increment";
    ClientEvents["CART_DECREMENT"] = "cart-decrement";
    ClientEvents["EXPLORE_SEGMENT_C2C_REFER_CLICK"] = "explore-segment-c2c-refer-click";
    ClientEvents["SHEF_SPOTLIGHT_CLICK"] = "shef-spotlight-click";
    ClientEvents["RECENTLY_REVIEWED_CLICK"] = "recently-reviewed-click";
    ClientEvents["NAV_HAMBUGER_MENU_CLICK"] = "nav-hamburger-menu-click";
    ClientEvents["NAV_CLICK"] = "nav-click";
    ClientEvents["AUTO_APPLIED_REWARD_PROMO"] = "auto-applied-reward-promo";
    ClientEvents["SHEF_MENU_VISIT"] = "shef-menu-visit";
    ClientEvents["DISH_MODAL_VISIT"] = "dish-modal-visit";
    ClientEvents["SHEF_PROFILE_IMAGE_CLICK"] = "shef-profile-image-click";
    ClientEvents["DISH_IMAGE_CLICK"] = "dish-image-click";
    ClientEvents["PREFAB_FOOD_ITEM_COPY"] = "prefab-food-item-copy";
    ClientEvents["FOOD_ITEM_SUGGESTIONS_VIEW"] = "food-item-suggestions-view";
    ClientEvents["AUTO_APPLIED_PROMO"] = "auto-applied-promo";
    ClientEvents["AUTO_APPLIED_SUBSCRIPTION_PROMO"] = "auto-applied-subscription-promo";
    ClientEvents["BECOME_A_SHEF_CLICK_GET_STARTED"] = "become-a-shef-click-get-started";
    ClientEvents["BECOME_A_SHEF_ENTER_INFO"] = "become-a-shef-enter-info";
    ClientEvents["BECOME_A_SHEF_CLICK_SIGN_UP"] = "become-a-shef-click-sign-up";
    ClientEvents["LOGIN_MODAL_EMAIL_LOGIN_SUBMIT"] = "login-modal-email-login-submit";
    ClientEvents["LOGIN_FAILED"] = "login-failed";
    ClientEvents["LOGIN_MODAL_SIGNUP_SUBMIT"] = "login-modal-signup-submit";
    ClientEvents["SIGN_UP_ERROR"] = "sign-up-error";
    ClientEvents["SSO_AUTH_SUCCESS"] = "sso-auth-success";
    ClientEvents["SSO_AUTH_FAILED"] = "sso-auth-failed";
    ClientEvents["REGISTER_SUCCESS"] = "register-success";
    ClientEvents["LOGIN_MODAL_OPENED"] = "login-modal-opened";
    ClientEvents["LOGIN_MODAL_DISMISSED"] = "login-modal-dismissed";
    ClientEvents["LOGIN_MODAL_SIGNUP_PAGE"] = "login-modal-signup-page";
    ClientEvents["LOGIN_MODAL_EMAIL_LOGIN_PAGE"] = "login-modal-email-login-page";
    ClientEvents["LOGIN_MODAL_EMAIL_ENTERED"] = "login-modal-email-entered";
    ClientEvents["LOGIN_MODAL_FORGOT_PASSWORD_CLICKED"] = "login-modal-forgot-password-clicked";
    ClientEvents["SSO_SIGNUP_CLICKED"] = "sso-signup-clicked";
    ClientEvents["CHECKOUT_DELIVERY_ADDRESS_SELECT"] = "checkout-delivery-address-select";
    ClientEvents["CHECKOUT_DELIVERY_TIME_SELECT"] = "checkout-delivery-time-select";
    ClientEvents["CHECKOUT_CREDIT_CARD_INPUT"] = "checkout-credit-card-input";
    ClientEvents["CHECKOUT_TIP_VALUE_UPDATE"] = "checkout-tip-value-update";
    ClientEvents["CHECKOUT_ORDER_ERROR"] = "checkout-order-error";
    ClientEvents["CHECKOUT_LEGAL_PROMPT"] = "checkout-legal-prompt";
    ClientEvents["CHECKOUT_PROMO_EXIT_INTENT_MODAL_SHOW"] = "checkout-promo-exit-intent-modal-show";
    ClientEvents["CHECKOUT_PROMO_EXIT_INTENT_MODAL_PROMO_CODE_APPLIED"] = "checkout-promo-exit-intent-modal-promo-code-applied";
    ClientEvents["CHECKOUT_PROMO_EXIT_INTENT_MODAL_DISMISS"] = "checkout-promo-exit-intent-modal-dismiss";
    ClientEvents["NEW_USER_EDUCATION_VIEW"] = "new-user-education-view";
    ClientEvents["NEW_USER_EDUCATION_STEP"] = "new-user-education-step";
    ClientEvents["CONSUMER_TRIAL_EXPLANATION_VIEW"] = "consumer-trial-explanation-view";
    ClientEvents["CONSUMER_TRIAL_ONBOARDING_VIEW"] = "consumer-trial-onboarding-view";
    ClientEvents["CONSUMER_TRIAL_ONBOARDING_ADVANCE"] = "consumer-trial-onboarding-advance";
    ClientEvents["CONSUMER_TRIAL_ONBOARDING_ACCEPT"] = "consumer-trial-onboarding-accept";
    ClientEvents["CONSUMER_HEADER_PROMO_BANNER_CLICK"] = "consumer-header-promo-banner-click";
    ClientEvents["CONSUMER_HEADER_PERSISTENT_PROMO_BANNER_DISMISSED"] = "consumer-header-persistent-promo-banner-dismissed";
    ClientEvents["COCKTAIL_ID_REMINDER_ACTION"] = "cocktail-id-reminder-action";
    ClientEvents["COCKTAIL_PURCHASE_ATTEMPT"] = "cocktail-purchase-attempt";
    ClientEvents["SHEF_FRINGE_MODAL_EXPLANATION_VIEW"] = "shef-fringe-modal-explanation-view";
    ClientEvents["SHEF_FRINGE_MODAL_MORE_VIEWED"] = "shef-fringe-modal-more-viewed";
    ClientEvents["SHEF_FRINGE_MODAL_DISMISSED"] = "shef-fringe-modal-dismissed";
    ClientEvents["SHEF_FRINGE_MODAL_ACCEPTED"] = "shef-fringe-modal-accepted";
    ClientEvents["SHEF_APPLICATION_TRACKER_SHOW"] = "shef-application-tracker-show";
    ClientEvents["SHEF_APPLICATION_TRACKER_HIDE"] = "shef-application-tracker-hide";
    ClientEvents["SHEF_APPLICATION_TRACKER_CLICK_STEP"] = "shef-application-tracker-click-step";
    ClientEvents["UPSELL_CLICK_ADD_TO_CART"] = "upsell-click-add-to-cart";
    ClientEvents["UPSELL_CLICK_CONTINUE"] = "upsell-click-continue";
    ClientEvents["UPSELL_CLICK_NO_THANKS"] = "upsell-click-no-thanks";
    ClientEvents["ATTEMPTED_REDIRECT_TO_CHROME_IOS"] = "attempted-redirect-to-chrome-ios";
    ClientEvents["ADD_TO_CALENDAR_CLICK"] = "add-to-calendar-click";
    ClientEvents["FOLLOW_SHEF_START"] = "follow-shef-start";
    ClientEvents["FOLLOW_SHEF_STOP"] = "follow-shef-stop";
    ClientEvents["SHEF_POST_VIEW"] = "shef-post-view";
    ClientEvents["VIEW_MENU_REVIEWS_SECTION"] = "view-menu-reviews-section";
    ClientEvents["CLICK_REVIEWS_BUTTON"] = "click-reviews-button";
    ClientEvents["VIEW_FOOD_SAFETY_POPOVER"] = "view-food-safety-popover";
    ClientEvents["REVIEW_FOOD_ITEM_IMAGE_CLICK"] = "review-food-item-image-click";
    ClientEvents["APP_REDIRECT"] = "app-redirect";
    ClientEvents["NAVIGATE_TO_APP_LISTING"] = "navigate-to-app-listing";
    ClientEvents["APP_UPSELL_BANNER_DISMISSED"] = "app-upsell-banner-dismissed";
    ClientEvents["WEDGE_PAGE_VIEW"] = "wedge-page-view";
    ClientEvents["DELIVERY_DATE_TOOLTIP_OPEN"] = "delivery-date-tooltip-open";
    ClientEvents["CHAT_WIDGET_OPEN"] = "chat-widget-open";
    ClientEvents["SHEF_MESSAGE_CLICK"] = "meal-plan-shef-message-click";
    ClientEvents["FLAGGED_CHAT_MODAL_EVENT"] = "flagged-chat-modal-event";
    ClientEvents["SHEF_ROSTER_SELECTOR_CLICK"] = "shef-selector-click";
    ClientEvents["SHEF_ROSTER_LOADED"] = "your-shefs-returned";
    ClientEvents["SHEF_MENU_CLICK"] = "shef-menu-click";
    ClientEvents["SHEF_ROSTER_ADD_FAVORITES"] = "shef-roster-add-favorites";
    ClientEvents["SHEF_ROSTER_ADD_FAVORITES_BROWSE_ALL"] = "shef-roster-add-favorites-browse-all";
    ClientEvents["SHEF_PROFILE_LOAD_MORE_REVIEWS"] = "shef-menu-load-more-reviews";
    ClientEvents["SINGLE_CART_STARTED_CHECKOUT"] = "single-cart-started-checkout";
    ClientEvents["MULTI_CART_STARTED_CHECKOUT"] = "multi-cart-started-checkout";
    ClientEvents["MULTI_CART_ADD_ORDER_BTN_CLICKED"] = "multi-cart-add-order-button-clicked";
    ClientEvents["MULTI_CART_STARTED_NEW_ORDER"] = "multi-cart-started-new-order";
    ClientEvents["DISH_FIRST_CART_CHANGE_DELIVERY_DATE"] = "dish-first-cart-change-delivery-date";
    ClientEvents["DISH_FIRST_CLICK_NEXT_DAY_BANNER"] = "dish-first-click-next-day-banner";
    ClientEvents["DISH_FIRST_LAZY_LOAD_QUICK_ADD_ITEM"] = "dish-first-lazy-load-quick-add-item";
    ClientEvents["REORDER_BUTTON_CLICK"] = "reorder-button-click";
    ClientEvents["RECURRING_SUBSCRIPTION_OPTION_SELECT"] = "recurring-subscription-option-select";
    ClientEvents["RECURRING_SUBSCRIPTION_CANCEL_BUTTON_CLICK"] = "recurring-subscription-cancel-button-click";
    ClientEvents["RECURRING_SUBSCRIPTION_SKIP_ORDER_BUTTON_CLICK"] = "recurring-subscription-skip-order-button-click";
    ClientEvents["SUBMIT_DISH_FILTER"] = "submit-dish-filter";
    ClientEvents["BROWSE_BY_TAGS_CLICK"] = "browse-by-tags-click";
    ClientEvents["DELIVERY_DAY_FILTER_ARROW_CLICK"] = "delivery-day-filter-arrow-click";
    ClientEvents["SEGMENT_ARROW_CLICK"] = "segment-arrow-click";
    ClientEvents["SEGMENT_SEE_ALL_LINK_CLICK"] = "segment-see-all-link-click";
    ClientEvents["SEGMENT_ITEM_CLICK"] = "clicked-segment-item";
    ClientEvents["BROWSE_BY_MEAL_TYPE_CLICK"] = "browse-by-meal-type-click";
    ClientEvents["BROWSE_BY_SHEF_CLICK"] = "browse-by-shef-click";
    ClientEvents["CELEBRITY_EVENT_EXPLORE_CLICK"] = "celebrity-event-explore-click";
    ClientEvents["INDIAN_MARKET_EXPLORE_CLICK"] = "indian-market-explore-click";
    ClientEvents["BULK_DISCOUNT_EXPLORE_CLICK"] = "bulk-discount-explore-click";
    ClientEvents["BULK_DISCOUNT_MODAL_VIEW"] = "bulk-discount-modal-view";
    ClientEvents["BULK_DISCOUNT_MODAL_CLOSE"] = "bulk-discount-modal-close";
    ClientEvents["DISH_DETAILS_TOGGLE_DETAILS"] = "dish-details-toggle-details";
    ClientEvents["DISH_DETAILS_SHEF_MENU_SEE_ALL_CLICK"] = "dish-details-shef-menu-see-all-click";
    ClientEvents["EXPLORE_SEE_MORE_CLICK"] = "explore-see-more-click";
    ClientEvents["EXPLORE_FOOD_ITEMS_RENDERED"] = "explore-food-items-rendered";
    ClientEvents["DEVICE_ZIP_TIME_ZONE_DIFFERENCE"] = "device-zip-time-zone-difference";
    ClientEvents["REUSABLE_PACKAGING_OPT_IN_SELECTION"] = "reusable-packaging-opt-in-selection";
    ClientEvents["INTAKE_REUSABLE_HOW_IT_WORKS_CLICK"] = "intake-reusable-how-it-works-click";
    ClientEvents["SHEF_DASHBOARD_MY_PROFILE_CLICK"] = "shef-dashboard-my-profile-click";
    ClientEvents["SHEF_DASHBOARD_MY_MENU_TAB_CLICK"] = "shef-dashboard-my-menu-tab-click";
    ClientEvents["SHEF_DASHBOARD_ADD_NEW_DISH_BTN_CLICK"] = "shef-dashboard-add-new-dish-btn-click";
    ClientEvents["SHEF_DASHBOARD_CREATE_NEW_FOOD_ITEM"] = "shef-dashboard-create-new-food-item";
    ClientEvents["SHEF_DASHBOARD_FOOD_ITEM_CHANGE_SAVE"] = "shef-dashboard-food-item-change-save";
    ClientEvents["SHEF_DASHBOARD_MY_RATINGS_TAB_CLICK"] = "shef-dashboard-my-ratings-tab-click";
    ClientEvents["SHEF_DASHBOARD_SEE_YOUR_REVIEWS_BTN_CLICK"] = "shef-dashboard-see-your-reviews-btn-click";
    ClientEvents["SHEF_DASHBOARD_PROMOTE_YOURSELF_COPY_LINK_CLICK"] = "shef-dashboard-promote-yourself-copy-link-click";
    ClientEvents["SHEF_DASHBOARD_ORDERS_BANNER_CLICK"] = "shef-dashboard-orders-banner-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_BANNER_CLICK"] = "shef-dashboard-referral-banner-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_DOWNLOAD_AD_CLICK"] = "shef-dashboard-referral-download-ad-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_MENU_LINK_CLICK"] = "shef-dashboard-referral-menu-link-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_HOW_IT_WORKS_LINK_CLICK"] = "shef-dashboard-referral-how-it-works-link-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_SHARE_TO_FACEBOOK_CLICK"] = "shef-dashboard-referral-share-to-facebook-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_SHARE_TO_WHATSAPP_CLICK"] = "shef-dashboard-referral-share-to-whatsapp-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_SHARE_TO_TWITTER_CLICK"] = "shef-dashboard-referral-share-to-twitter-click";
    ClientEvents["SHEF_DASHBOARD_REFERRAL_COPY_REFERRAL_CODE_CLICK"] = "shef-dashboard-referral-copy-referral-code-click";
    ClientEvents["SHEF_DASHBOARD_GROW_YOUR_BUSINESS_TAB_CLICK"] = "shef-dashboard-grow-your-business-tab-click";
    ClientEvents["SHEF_DASHBOARD_GROW_YOUR_BUSINESS_TAKE_ME_THERE"] = "shef-dashboard-grow-your-business-tab-take-me-there";
    ClientEvents["SHEF_DASHBOARD_GIVE_GET_PANEL_DETAILS_CLICK"] = "shef-dashboard-give-get-panel-details-click";
    ClientEvents["SHEF_DASHBOARD_GIVE_GET_PANAL_SHARE_LINK_CLICK"] = "shef-dashboard-give-get-panel-share-link-click";
    ClientEvents["SHEF_DASHBOARD_GIVE_GET_PANAL_COPY_LINK_CLICK"] = "shef-dashboard-grow-your-business-copy-link-click";
    ClientEvents["SHEF_DASHBOARD_GROW_YOUR_BUSINESS_SHEF_TO_SHEF"] = "shef-dashboard-grow-your-business-shef-to-shef";
    ClientEvents["SHEF_PRICE_OUT_OF_RANGE_MODAL"] = "shef-price-out-of-range-modal";
    ClientEvents["PERSONAL_SHEF_FORM_STEP"] = "personal-shef-form-step";
    ClientEvents["PERSONAL_SHEF_FORM_SUBMIT"] = "personal-shef-form-submit";
    ClientEvents["PERSONAL_SHEF_PLAN_CLICK"] = "personal-shef-plan-click";
    ClientEvents["PERSONAL_SHEF_BANNER_CLICK"] = "personal-shef-banner-click";
    ClientEvents["PERSONAL_SHEF_LANDING_PAGE_VISITED"] = "personal-shef-landing-page-visited";
    ClientEvents["PERSONAL_SHEF_LEARN_MORE_CLICK"] = "personal-shef-learn-more-click";
    ClientEvents["CLICK_HELP_WIDGET"] = "click-help-widget";
    ClientEvents["CELEBRITY_EVENT_ERROR"] = "celebrity-event-error";
    ClientEvents["WEB_PUSH_SUBSCRIPTION_CHANGE"] = "web-push-subscription-change";
    ClientEvents["WEB_PUSH_PERMISSION_PROMPT_DISPLAY"] = "web-push-permission-prompt-display";
    ClientEvents["WEB_PUSH_NOTIFICATION_PERMISSION_CHANGE"] = "web-push-notification-permission-change";
    ClientEvents["WEB_PUSH_POPOVER_SHOWN"] = "web-push-popover-shown";
    ClientEvents["WEB_PUSH_CUSTOM_PROMPT_CLICK"] = "web-push-custom-prompt-click";
    ClientEvents["WEB_PUSH_NOTIFICATION_DISPLAY"] = "web-push-notification-display";
    ClientEvents["WEB_PUSH_NOTIFICATION_DISMISS"] = "web-push-notification-dismiss";
    ClientEvents["REVIEW_GROUP_ORDER_BUTTON_CLICK"] = "review-group-order-button-click";
    ClientEvents["GROUP_ORDER_RATING_MODAL_SHOW"] = "group-order-rating-modal-show";
    ClientEvents["GROUP_ORDER_RATING_MODAL_STEP"] = "group-order-rating-modal-step";
    ClientEvents["GROUP_ORDER_RATING_MODAL_PARTIAL_SAVE"] = "group-order-rating-modal-partial-save";
    ClientEvents["GROUP_ORDER_RATING_MODAL_SUBMIT"] = "group-order-rating-modal-submit";
    ClientEvents["GROUP_ORDER_RATING_MODAL_SUBMIT_SUCCESS"] = "group-order-rating-modal-submit-success";
    ClientEvents["GROUP_ORDER_RATING_MODAL_SUBMIT_FAILURE"] = "group-order-rating-modal-submit-failure";
    ClientEvents["RATE_RECENT_GROUP_ORDER_MODAL_SHOW"] = "rate-recent-group-order-modal-show";
    ClientEvents["RATE_RECENT_GROUP_ORDER_MODAL_CLICK"] = "rate-recent-group-order-modal-click";
    ClientEvents["WAITLIST_ACTION_CLICKED"] = "waitlist-action-clicked";
    ClientEvents["BROWSER_TRACKER_RECONCILIATION"] = "browser-tracker-reconciliation";
    ClientEvents["REFERRAL_REDIRECT"] = "referral-redirect";
    ClientEvents["FOOD_ITEM_PRICE_RECOMMENDATION"] = "food-item-price-recommendation";
    ClientEvents["SHEF_MENU_NAV_CLICK"] = "shef-menu-nav-click";
    ClientEvents["TRACKING_PERMISSION_REQUESTED"] = "tracking-permission-requested";
    ClientEvents["PUSH_NOTIFICATION_OPEN"] = "push-notification-open";
    ClientEvents["PUSH_NOTIFICATION_PROMPT_SHOW"] = "push-notification-prompt-show";
    ClientEvents["PUSH_NOTIFICATION_PROMPT_HIDE"] = "push-notification-prompt-hide";
    ClientEvents["PUSH_NOTIFICATION_PERMISSION_REQUESTED"] = "push-notification-permission-requested";
    ClientEvents["APP_REVIEW_REQUEST_ATTEMPT"] = "app-review-request-attempt";
    ClientEvents["APP_REVIEW_REQUEST_FAILED"] = "app-review-request-failed";
    ClientEvents["APP_REVIEW_REQUEST_SKIPPED"] = "app-review-request-skipped";
    ClientEvents["APP_REVIEW_REQUESTED"] = "app-review-requested";
    ClientEvents["LOCATION_SOURCE_SELECTED"] = "location-source-selected";
    ClientEvents["LOCATION_PERMISSION_REQUESTED"] = "location-permission-requested";
    ClientEvents["LOCATION_SET"] = "location-set";
    ClientEvents["PRE_CHECKOUT_UPSELL_MODAL_VIEW"] = "pre-checkout-upsell-modal-view";
    ClientEvents["PRE_CHECKOUT_UPSELL_MODAL_CLOSE"] = "pre-checkout-upsell-modal-close";
    ClientEvents["PRE_CHECKOUT_UPSELL_ADD_ALL"] = "pre-checkout-upsell-add-all";
    ClientEvents["PRE_CHECKOUT_UPSELL_REFRESH_SUGGESTIONS"] = "pre-checkout-upsell-refresh-suggestions";
})(ClientEvents = exports.ClientEvents || (exports.ClientEvents = {}));
var DeprecatedClientEvents;
(function (DeprecatedClientEvents) {
    DeprecatedClientEvents["SEARCH"] = "search";
    DeprecatedClientEvents["SELECT_DELIVERY_DAY_SHEF"] = "select-delivery-day-shef";
    DeprecatedClientEvents["SEARCH_TEXT_CHANGED"] = "search-text-changed";
})(DeprecatedClientEvents = exports.DeprecatedClientEvents || (exports.DeprecatedClientEvents = {}));
//# sourceMappingURL=ClientEvents.js.map